// Bestellung per E-Mail an den Lieferanten (docs/anmeldung/SPEZIFIKATION.md §5.3, §8.2): nur bestellte
// (festgeschriebene) Bestellungen; die Positionen mit Bestelleinheit und Einkaufspreis stehen im Mailtext – die E-Mail
// ist für den Lieferanten bestimmt. Inhalt und Rohfassung im Postausgang sieht nur, wer zusätzlich „Einstandspreise
// sehen“ hält (confidential costs.read); dasselbe gilt für die Vorschau im Senden-Dialog. Die Oberfläche bietet
// „Bestellen und per E-Mail senden“ als zwei Aufrufe nacheinander (purchasing.order.post, dann diese Aktion).
import { defineContract } from '@shared/contract'
import { zDocumentMailInput, zMailPreviewResult, zMailQueuedResult } from '@shared/mailSend'

export const PURCHASING_SEND_PERMISSION = 'purchasing.order.send'

export const orderSend = defineContract({
  name: 'purchasing.order.send',
  title: 'Bestellung per E-Mail senden',
  description: 'Sendet eine bestellte Bestellung per E-Mail an den Lieferanten – die Positionen stehen im Mailtext.',
  llm: {
    description:
      'Sendet EINE bestellte (festgeschriebene) Bestellung per E-Mail an den Lieferanten. Ohne `to` an die Bestelladresse ' +
      'des Lieferanten (wenn sein Bestellweg E-Mail ist), sonst an seine E-Mail. Die Mail enthält die Einkaufspreise. ' +
      'Persönliche Nachricht höchstens 1000 Zeichen. Versand nach dem Rückgängig-Fenster. Erst bestellen ' +
      '(purchasing.order.post), dann senden.',
    keywords: ['Bestellung schicken', 'Bestellung per E-Mail', 'beim Lieferanten bestellen', 'Bestellung mailen'],
  },
  input: zDocumentMailInput,
  output: zMailQueuedResult,
  permission: PURCHASING_SEND_PERMISSION,
  risk: 'write',
  scope: 'record',
  effects: { external: true, reversible: true },
})

export const orderSendPreview = defineContract({
  name: 'purchasing.order.sendPreview',
  title: 'Bestellung per E-Mail – Vorschau',
  description: 'Zeigt, wie die E-Mail mit der Bestellung aussieht: Empfänger-Vorschlag, Betreff und – mit „Einstandspreise sehen“ – den Inhalt.',
  llm: { description: 'Zeigt die E-Mail zu einer Bestellung, bevor sie versendet wird. Verändert nichts. Versenden: purchasing.order.send.', keywords: [] },
  input: zDocumentMailInput,
  output: zMailPreviewResult,
  permission: PURCHASING_SEND_PERMISSION,
  risk: 'read',
  scope: 'record',
})
